export const router_must_sign = [
    "login", "taxfill", "register", "recover_password", "user/set_new_password", "user/active_account", "quick-login", "user/onetimepassword"
]
